import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetWaveform: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 12h1l2-4 2 8 2-8 2 4 2-6 2 6 2-3 1 3h1" />
      </svg>
    </div>
  );
};

export default WidgetWaveform;
